import Alert from 'react-bootstrap/Alert';

function AlertF() {
  return (
    <>
        {[
            'danger',
            ].map((variant) => (
            <Alert className='text-center' key={variant} variant={variant}>
                Website Under Development. Beta Version 2.1.15 @ August 2025
            </Alert>
        ))}
    </>
  );
}

export default AlertF;